"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyleText = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("webmotors-react-pj/tokens/color"));
var _responsive = _interopRequireDefault(require("webmotors-react-pj/tokens/responsive"));
const StyleText = exports.StyleText = _styledComponents.default.footer.withConfig({
  displayName: "StyleText",
  componentId: "sc-1bs593l-0"
})(["font-family:Figtree;"]);